import { useEffect, useState } from "react";

const useIsAirbudsClient = () => {
  const [isAirbudsClient, setIsAirbudsClient] = useState(false);

  useEffect(() => {
    setIsAirbudsClient(!(typeof webkit === "undefined"));
  }, []);

  return isAirbudsClient;
};

export default useIsAirbudsClient;
